/** Layout offset for the workspace rail. Stored Home icon positions are not modified. */
export const WORKSPACE_RAIL_WIDTH_PX = 56;
export const WORKSPACE_NARROW_MAX_PX = 767;
export const WORKSPACE_NARROW_CHROME_HEIGHT_PX = 48;

export function readViewportWidth() {
  if (typeof window === 'undefined') return 1280;
  const width = window.innerWidth;
  return Number.isFinite(width) && width > 0 ? width : 1280;
}

export function workspaceCanvasOffset(viewportWidth, railVisible = true) {
  const width = Number(viewportWidth);
  if (!railVisible || !Number.isFinite(width) || width <= 0) {
    return { paddingLeft: 0, paddingTop: 0 };
  }
  if (width <= WORKSPACE_NARROW_MAX_PX) {
    return { paddingLeft: 0, paddingTop: WORKSPACE_NARROW_CHROME_HEIGHT_PX };
  }
  return { paddingLeft: WORKSPACE_RAIL_WIDTH_PX, paddingTop: 8 };
}

export function applyWorkspaceRailCssVars(root, { viewportWidth, railVisible }) {
  if (!root?.style) return;
  const offset = workspaceCanvasOffset(viewportWidth, railVisible);
  root.style.setProperty('--sb-workspace-rail-width', `${offset.paddingLeft}px`);
  root.style.setProperty('--sb-workspace-chrome-top', `${offset.paddingTop}px`);
}

export function clearWorkspaceRailCssVars(root) {
  if (!root?.style) return;
  root.style.removeProperty('--sb-workspace-rail-width');
  root.style.removeProperty('--sb-workspace-chrome-top');
}

/** Adds canvas padding only. Callers must not pass stored icon coordinates. */
export function offsetHomeCanvas(style, viewportWidth, railVisible = true) {
  const offset = workspaceCanvasOffset(viewportWidth, railVisible);
  return {
    ...style,
    boxSizing: 'border-box',
    paddingLeft: `${offset.paddingLeft}px`,
    paddingTop: `${offset.paddingTop}px`,
  };
}
